import _ from 'lodash';
import PageContainer from './PageContainer';
import session from '../models/Session';
import Draft from '../models/Draft';

export default class PromptContainer extends PageContainer {
  state={
    prompts: {},
    draft: null,
    selectedParents: [],
  }

  options = {
    getFromSession: ['selectedParents', 'draft'],
    defaultState: {
      draft: Draft.mock()
    }
  }

  async setup() {
    await this.subscribeToSession();

    // No draft available in session, use default values 
    if (!this.state.draft) {
      let draft = null; 

      if (session.template && session.selectedParents) {
        draft = await session.createDraft();
      } else {
        draft = await Draft.mock().fetchLocal();

        if (!draft) {
          draft = Draft.mock(); 
        }
      }

      await this.setState(state => _.assign(state, {draft, prompts: draft.prompts}));
    }

    this.state.draft.changes$.subscribe((next) => {
      this.state.draft.save();
    });

    this.subscribeToStore(this.state.draft, ['prompts']);

    console.log('PrompContainer:done setup', this.state, session);
  }

  destroy() {
    this.unsubscribeAll();
  }

  handleOnChangePrompt = (value, object) => {
    // this.updatePromptForDraft(object._id, value);
    this.setState({
      prompts: { ...this.state.prompts, [object._id]: value },
      draft: this.state.draft.set('prompts', {...this.state.prompts, [object._id]: value})
    });
  }
}



// WEBPACK FOOTER //
// ./src/containers/PromptContainer.js